import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../lib/firebase";
import { getUserProfile } from "../lib/auth";
import { logout as firebaseLogout } from "../lib/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      // If email not verified, don't route them in — just stay on login
      // But don't sign them out here — let LoginPage handle that
      // so the verification screen can still show
      if (!firebaseUser.emailVerified) {
        const profile = await getUserProfile(firebaseUser.uid);
        // Admins bypass verification
        if (profile?.role === "admin") {
          setUser(profile);
        } else {
          // Unverified customer — don't set user, stay on login page
          setUser(null);
        }
        setLoading(false);
        return;
      }

      const profile = await getUserProfile(firebaseUser.uid);
      setUser(profile || null);
      setLoading(false);
    });
    return unsub;
  }, []);

  const logout = async () => {
    await firebaseLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
